import React from "react";
import PlanCard from "./PlanCard";
import plansData from "../../data/plansData";

const Plans = () => {
  return (
    <section className="plans">
      <div className="container">

        <div className="row">

          <div className="col-12">
            <h2>Subscription Plans</h2>

            <p className="headText">
              Recommend for Family of 2 members
            </p>
          </div>

          {plansData.family2.map((plan, index) => (
            <PlanCard key={index} {...plan} />
          ))}

        </div>

        <div className="row mt-5">

          <div className="col-12">
            <h2>
              Most Recommended For Family of 3+ Members
            </h2>

            <p className="headText">
              Over 25000 customers have already opted below AMC Plans
            </p>
          </div>

          {plansData.family3.map((plan, index) => (
            <PlanCard key={index} {...plan} />
          ))}

        </div>

      </div>
    </section>
  );
};

export default Plans;